import { useConnectWallet } from '@lair-finance/wallet'
import { useEffect } from 'react'
import { getModalControlStore } from '@/domains/header/model/store.ts'

export function useCloseMenuOnDisconnect() {
  const { isConnected } = useConnectWallet()

  useEffect(() => {
    if (!isConnected) {
      getModalControlStore().closeModal()
    }
  }, [isConnected])
}
